/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import {
  EmploymentStatus,
  ProductLength,
  RepaymentMethod,
  UkLocation,
} from '../../models';

// Map UkLocation onto Asanto string equivalents
export const regionMap = new Map<UkLocation, string>([
  [UkLocation.EastMidlands, 'East Midlands'],
  [UkLocation.EastOfEngland, 'East of England'],
  [UkLocation.GreaterLondon, 'Greater London'],
  [UkLocation.NorthEast, 'North East'],
  [UkLocation.NorthWest, 'North West'],
  [UkLocation.SouthEast, 'South East'],
  [UkLocation.SouthWest, 'South West'],
  [UkLocation.WestMidlands, 'West Midlands'],
  [UkLocation.YorkshireAndHumberside, 'Yorkshire & Humberside'],
  [UkLocation.Scotland, 'Scotland'],
  [UkLocation.Wales, 'Wales'],
]);

export const repaymentTypeMap = new Map<RepaymentMethod, string>([
  [RepaymentMethod.CapitalAndInterest, 'Capital & Interest'],
  [RepaymentMethod.InterestOnly, 'Interest Only'],
  [RepaymentMethod.InterestOnlyPartAndPart, 'Interest Only - Part & Part'],
]);

export const employmentStatusMap = new Map<EmploymentStatus, string>([
  [EmploymentStatus.Employed, 'Employed'],
  [EmploymentStatus.SelfEmployed, 'Self employed (sole trader/partner)'],
  [EmploymentStatus.DirectorOrShareholder, 'Director/Shareholder'],
  [EmploymentStatus.Homemaker, 'Homemaker'],
  [EmploymentStatus.Retired, 'Retired'],
  [EmploymentStatus.Student, 'Student'],
  [EmploymentStatus.Unemployed, 'Unemployed'],
]);

export const twoDigits = (x: number) => `${x}`.padStart(2, '0');

export function toProductLength(productLength: ProductLength) {
  switch (productLength) {
    case ProductLength.OneYear:
      return '1 year';
    case ProductLength.FiveYears:
      return '5 years +';
    default:
      return `${+productLength} years`;
  }
}

export function monthlyToAnnual(amount: number): number {
  return amount * 12;
}

export function getAge(dob: Date): number {
  const now = new Date();
  const years = now.getFullYear() - dob.getFullYear();
  const monthInYearDiff = now.getMonth() - dob.getMonth();
  const dayInMonthDiff = now.getDate() - dob.getDate();

  return monthInYearDiff > 0 || (monthInYearDiff === 0 && dayInMonthDiff >= 0) ? years : years - 1;
}
